import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadingSpinnerService } from '../../services/common/loading-spinner.service';

@Component({
  selector: 'app-landing',
  imports: [RouterOutlet, NgxSpinnerModule, TranslatePipe],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  constructor(public readonly loadingSpinnerService: LoadingSpinnerService) { }
}
